import { analyticsByRoute } from '../helpers/registration';
import {
	initiatePageViewTracking,
	getPlatformData,
	addToGlobalContexts,
	removeFromGlobalContext,
} from '../components/analytics/Snowplow';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

export default function useInitTrackPageView(isLoading) {
	const location = useLocation();
	const gigyaUser = useSelector((state) => state.authentication.gigyaUser);

	const newLocation = location.pathname;

	const data = analyticsByRoute[newLocation.replace(/\/+$/, '')];
	const locationToMap = location.pathname;

	useEffect(() => {
		const platformData = getPlatformData({ location: locationToMap });
		if (!platformData) return;

		addToGlobalContexts({
			rtlPlatform: { ...platformData },
		});
		return () => {
			removeFromGlobalContext({ rtlPlatform: { ...platformData } });
		};
	}, [locationToMap]);

	useEffect(() => {
		if (!isLoading) {
			const trackingData = data && {
				pageNamePlatform: data.pageName,
				rtlUser: data.useRtlUser && gigyaUser?.UID && { rtlUserId: gigyaUser.UID },
			};

			initiatePageViewTracking({
				...(trackingData && trackingData),
			});
		}
	}, [data, isLoading, gigyaUser.UID]);
}
